/**
 * external libs
 */
import React, {createContext, useRef, useState} from 'react';
import CardPicker from "../../components/CardPicker";
import {CARD_ON_CARD_LIST_PER_PAGE} from "../../constants/ui.constant";
import Draggable from 'react-draggable';

export const CardListContext = createContext({});

export function CardListContextProvider({children}) {
    const [cardListSearch, setCardListSearch] = useState([])
    const searchTimeout = useRef(null);

    const setCardListSearchHandler = (search, index) => {
        clearTimeout(searchTimeout.current)
        let cardListSearchCopy = JSON.parse(JSON.stringify(cardListSearch));
        if(cardListSearchCopy[index] === search ){
            return
        }

        cardListSearchCopy[index] = search;
        cardListSearchCopy = cardListSearchCopy.reduce((accum, searchItem) => {
            if (searchItem) {
                return [...accum, searchItem]
            }

            return accum
        }, [])

        searchTimeout.current = setTimeout(() => {
            setCardListSearch(cardListSearchCopy)
        }, 500)
    }

    const clear = () => {
        setCardListSearch([])
    }

    return (
        <CardListContext.Provider value={{setCardListSearch: setCardListSearchHandler}}>
            {!!cardListSearch.length && (
                <Draggable handle={"thead"}>
                    <div className={"drag_thead"} style={{position: "fixed", top: 32, right: 32, background: "white", color: "black", zIndex: 9999,
                        boxShadow: "0 0 6px 5px rgba(0, 0, 0, .3)",
                        overflow: "hidden",
                        borderRadius: 16,
                        paddingBottom: 20
                    }}>
                        <div style={{position: "absolute", top: 5, right: 10, zIndex: 1, cursor: "pointer"}} onClick={clear}>
                            <svg fillRule="evenodd" viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em"
                                 height="1em" fill="currentColor" aria-hidden="true">
                                <path
                                    d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"></path>
                            </svg>
                        </div>
                        <CardPicker pickerType={null}
                                    perPage={CARD_ON_CARD_LIST_PER_PAGE}
                                    initialMembers={[]}
                                    cardListSearch={cardListSearch.join(' ')}/>
                    </div>
                </Draggable>
            )}
            {children}
        </CardListContext.Provider>
    );
}
